// extracted by mini-css-extract-plugin
module.exports = {"ProseMirror":"Select_ProseMirror__VBxrZ","indicator":"Select_indicator__3xlbl","indicator__icon":"Select_indicator__icon__6YSA2","rotate-shadow":"Select_rotate-shadow__3WKTO"};